import { createFileRoute } from '@tanstack/react-router';
import { DirectoryPage } from '@/features/directory';

/** The directory of the offices that opted in (any signed-in member): search, then contact. */
export const Route = createFileRoute('/_auth/o/$orgId/directory')({
  component: DirectoryPage,
});
